<script setup lang="ts">
import { nextTick, onMounted, watch } from 'vue'
import { useRoute } from 'vue-router'
import { focusHeading } from '@/utils/motion'
import NavBar from '@/components/layout/NavBar.vue'
import AppFooter from '@/components/layout/AppFooter.vue'
import AboutLpHeroSection from '@/components/marketing/about/AboutLpHeroSection.vue'
import AboutLpStorySection from '@/components/marketing/about/AboutLpStorySection.vue'
import AboutLpMissionSection from '@/components/marketing/about/AboutLpMissionSection.vue'
import AboutLpValuesSection from '@/components/marketing/about/AboutLpValuesSection.vue'
// Hidden until the platform has figures worth showing; re-enable together with the template line below.
// import AboutLpNumbersSection from '@/components/marketing/about/AboutLpNumbersSection.vue'
import AboutLpTeamSection from '@/components/marketing/about/AboutLpTeamSection.vue'
import AboutLpHowWeHelpSection from '@/components/marketing/about/AboutLpHowWeHelpSection.vue'
import AboutLpContactSection from '@/components/marketing/about/AboutLpContactSection.vue'
import AboutLpFaqTeaserSection from '@/components/marketing/about/AboutLpFaqTeaserSection.vue'
import OrganizerLpCtaBannerSection from '@/components/marketing/organizers/OrganizerLpCtaBannerSection.vue'

const route = useRoute()

// Deep links (#contact, also reached via the /contact redirect) land on the section heading.
async function focusHashTarget(): Promise<void> {
  if (route.hash !== '#contact') return
  await nextTick()
  focusHeading('contact-title')
}

onMounted(() => void focusHashTarget())
watch(() => route.hash, () => void focusHashTarget())
</script>

<template>
  <div class="flex flex-col min-h-screen">
    <NavBar />
    <main class="flex-1">
      <AboutLpHeroSection variant="public" />
      <AboutLpStorySection variant="public" />
      <AboutLpMissionSection />
      <AboutLpValuesSection variant="public" />
      <!-- <AboutLpNumbersSection /> -->
      <AboutLpTeamSection variant="public" />
      <AboutLpHowWeHelpSection />
      <AboutLpContactSection />
      <AboutLpFaqTeaserSection />
      <OrganizerLpCtaBannerSection />
    </main>
    <AppFooter />
  </div>
</template>
